package com.klantenstop.web.pages.authentication.login

import com.klantenstop.web.auth.AuthModule
import com.materialkobweb.components.toast.ToastManager
import com.klantenstop.web.utils.AnalyticsManager
import com.klantenstop.web.utils.MVI
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class LoginViewModel : ViewModel(), MVI<LoginContract.State, LoginContract.Intent, LoginContract.Effect> {

    private val _state = MutableStateFlow(LoginContract.State())
    override val state = _state.asStateFlow()

    private val _effect = MutableSharedFlow<LoginContract.Effect>()
    override val effect = _effect.asSharedFlow()

    override fun sendIntent(intent: LoginContract.Intent) = coroutineScope.launch {
        when (intent) {
            is LoginContract.Intent.Login -> login()
            is LoginContract.Intent.UpdateEmail -> updateState { it.copy(emailAddress = intent.value) }
            is LoginContract.Intent.UpdatePassword -> updateState { it.copy(password = intent.value) }
        }
    }

    private suspend fun login() {
        val email = _state.value.emailAddress
        val password = _state.value.password

        updateState { it.copy(hasAttemptedLogin = true) }

        if (email.isEmpty() || password.isEmpty()) {
            ToastManager.warning("Vul alle velden in", title = "Ongeldige invoer")
            return
        }

        try {
            val authState = AuthModule.login(email, password)
            check(authState.authenticated) { "Inloggen gelukt, maar sessie kon niet worden gevalideerd." }

            ToastManager.success("Je bent succesvol ingelogd!", title = "Welkom")
            AnalyticsManager.trackEvent(AnalyticsManager.Events.LOGIN_COMPLETED)
            emitEffect(LoginContract.Effect.NavigateToNextScreen)
        } catch (e: Exception) {
            ToastManager.error(e.message ?: "Er is een fout opgetreden bij het inloggen", title = "Inloggen mislukt")
        }
    }

    override fun emitEffect(effect: LoginContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (LoginContract.State) -> LoginContract.State) {
        _state.update(block)
    }
}
